export default "__VITE_ASSET__bGrDIgsI__"